"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Label_1 = require("./../Label");
var PriceContainer_1 = require("./../../cards/PriceContainer");
var StarRating_1 = require("./../StarRating");
var Image_1 = require("./../Image");
// Styles.
var ProductCardStyles = require("./ProductCard.css");
var ProductCard = /** @class */ (function (_super) {
    __extends(ProductCard, _super);
    function ProductCard(props) {
        var _this = _super.call(this, props) || this;
        _this.stopPropagation = function (e) {
            e.stopPropagation();
        };
        _this.buildOptionsToStateObject = function (options, breakpoint) {
            var style = _this.style;
            var priceFontSize = ProductCardStyles.typeBaseFixed;
            return {
                bannerClass: options.bannerClass,
                bannerTextClass: options.bannerTextClass,
                addFavouriteClass: options.addFavouriteClass,
                addFavouriteIconHover: options.addFavouriteIconHover,
                className: [options.className, style.productCard].join(' '),
                contentClass: options.contentClass,
                copyClass: [options.copyClass].join(' '),
                copyTag: options.copyTag,
                discountDetailsClass: [options.discountDetailsClass, ProductCardStyles.priceBlockMar].join(' '),
                discountDetailsLabel: [options.discountDetailsLabel, ProductCardStyles.discLabel].join(' '),
                discountDetailsTag: options.discountDetailsTag,
                eyebrowClass: options.eyebrowClass,
                eyebrowTag: options.eyebrowTag,
                gridColClass: options.gridColClass,
                headingClass: [options.headingClass, ProductCardStyles.headingWidth,
                    ProductCardStyles.typeBaseFixed].join(' '),
                headingTag: options.headingTag,
                imgClass: options.imgClass,
                initialPriceClass: [options.initialPriceClass, ProductCardStyles.typeXsFixed,
                    ProductCardStyles.initialPriceTypeFixed].join(' '),
                innerContainerClass: options.innerContainerClass,
                legalClass: [options.legalClass].join(' '),
                outerContainerClass: [options.outerContainerClass, ProductCardStyles.productCardContainer].join(' '),
                priceClass: [options.priceClass, priceFontSize, ProductCardStyles.priceTypeFixed].join(' '),
                rowClass: options.rowClass,
                subHeadingClass: [options.subHeadingClass, ProductCardStyles.typeXsFixed].join(' '),
                subHeadingTag: options.subHeadingTag,
            };
        };
        var options = props.options;
        var breakpoint = options.breakpoint;
        _this.style = options.style || ProductCardStyles;
        _this.state = __assign({}, _this.buildOptionsToStateObject(options, breakpoint));
        return _this;
    }
    ProductCard.prototype.componentDidMount = function () {
        var maxHeight = -1;
        var elements = document.getElementsByClassName('equalHeight');
        var elems = [].slice.call(elements); // Now a true Array
        elems.forEach(function (e) {
            maxHeight = Math.max(maxHeight, e.offsetHeight);
        });
        elems.forEach(function (e) {
            if (maxHeight > 63) {
                e.style.height = '63px';
            }
            else {
                e.style.height = maxHeight + 'px';
            }
        });
    };
    // This should be looked at and potentially updated to getDerivedStateFromProps in future versions.
    // UNSAFE_componentWillReceiveProps will go away in React version 17!!!
    ProductCard.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        if (JSON.stringify(nextProps.options) !== JSON.stringify(this.props.options)) {
            this.setState(nextProps.options);
        }
    };
    ProductCard.prototype.render = function () {
        var props = this.props;
        var options = props.options;
        var state = this.state;
        var breakpoint = options.breakpoint;
        return (React.createElement("div", { className: state.outerContainerClass, onClick: this.props.onClick },
            React.createElement("div", { className: "row flex-wrap" },
                React.createElement("div", { className: state.innerContainerClass + " " + this.style.innerClass },
                    React.createElement("div", { className: "bg-ui-white " + this.style.hoverFocus + " " + this.style.maxHight + " " + this.props.options.maxHeight },
                        React.createElement("div", { className: state.rowClass },
                            React.createElement("div", { className: "grid-col-6 rel " + this.style.imageContainer },
                                this.getFavourateIcon(),
                                this.getImage(this.props.data.imgUrl, state.imgClass),
                                this.colorOptions()),
                            React.createElement("div", { className: "grid-col-6 pad-t-none pad-r-none pad-b-sm rel\n                                            " + this.style.offerMain },
                                this.offerBanner(),
                                React.createElement("div", { className: "pad-r-sm pad-t-md-all " + this.style.contentClass },
                                    this.props.data.showTopArrow ? (React.createElement("div", { className: this.style.offercaret })) : '',
                                    React.createElement("div", { className: "flex flex-items-center type-sm-fixed\n                                                    " + this.style.ratingContainer }, 
                                    // only render star ratings if rate is truthy
                                    Boolean(props.data.rate) &&
                                        (React.createElement(React.Fragment, null,
                                            React.createElement(StarRating_1.default, { data: {
                                                    name: this.props.data.name,
                                                    rate: this.props.data.rate,
                                                    readOnly: this.props.data.readOnly,
                                                    starCount: this.props.data.starCount,
                                                } }),
                                            React.createElement("div", { className: "mar-l-xxxs mar-b-none\n                                                                  " + this.style.starRate },
                                                props.data.rate,
                                                " | ",
                                                props.data.starReviews)))),
                                    this.props.data.eyebrow ? (React.createElement(Label_1.default, { data: {
                                            isDecodingRequired: false,
                                            text: this.props.data.eyebrow,
                                        }, options: {
                                            className: state.eyebrowClass + " " + ProductCardStyles.typeXsFixed,
                                            tag: state.eyebrowTag,
                                        } })) : null,
                                    React.createElement("div", { className: "color-ui-black rel " + ProductCardStyles.textContainer },
                                        this.props.data.heading ? (React.createElement("span", { title: this.props.data.heading },
                                            React.createElement(Label_1.default, { data: {
                                                    isDecodingRequired: false,
                                                    text: this.props.data.heading,
                                                }, options: {
                                                    accessibility: this.props.data.heading,
                                                    className: state.headingClass + "\n                                                                    " + this.props.options.productEllipsisClass + "\n                                                                    " + ProductCardStyles.txtdisplay + "\n                                                                    " + ProductCardStyles.truncate,
                                                    size: state.headingSize,
                                                    tag: state.headingTag,
                                                } }))) : null,
                                        this.props.data.copy ? (React.createElement(Label_1.default, { data: {
                                                isDecodingRequired: false,
                                                text: this.props.data.copy,
                                            }, options: {
                                                className: state.copyClass + " " + ProductCardStyles.copyClass,
                                                tag: state.copyTag,
                                            } })) : null),
                                    React.createElement("div", { className: "type-xxs mar-b-none color-ui-dark-gray rel\n                                                    " + ProductCardStyles.initPrice }, this.props.data.initialPrice ? (React.createElement(PriceContainer_1.default, { data: {
                                            billingNote: this.props.data.billingNote,
                                            price: parseFloat(this.props.data.initialPrice),
                                        }, options: {
                                            className: state.initialPriceClass,
                                            decimalPoints: 2,
                                            isDataPriceNegative: false,
                                            paymentMonth: ProductCardStyles.paymentMonth,
                                            type: this.props.data.pricingType,
                                        } })) : null),
                                    React.createElement("div", { className: "price flex-wrap color-ui-black rel\n                                                " + this.style.prodPrice + "\n                                                " + this.props.options.defprice }, this.props.data.price ? (React.createElement(PriceContainer_1.default, { data: {
                                            billingNote: this.props.data.billingNote,
                                            discountDetails: this.props.data.priceDetails,
                                            price: parseFloat(this.props.data.price),
                                        }, options: {
                                            className: state.priceClass,
                                            customClasses: {
                                                discountDetails: state.discountDetailsClass,
                                                discountDetailsLabel: state.discountDetailsLabel,
                                                minusClass: state.priceMinusClass,
                                            },
                                            decimalPoints: 2,
                                            discountDetailsTag: state.discountDetailsTag,
                                            displayFree: true,
                                            isDataPriceNegative: false,
                                            isFreeClass: ProductCardStyles.freeClass,
                                            type: this.props.data.pricingType,
                                        } })) : null),
                                    this.props.data ? (React.createElement("div", { className: this.props.options.legalClass + "\n                                              " + ProductCardStyles.legalContent },
                                        this.props.shortLegalString,
                                        this.props.data.longLegal)) : null),
                                React.createElement("div", { className: "flex flex-items-bottom\n                                            " + this.style.footerContainer }, this.props.data && this.props.data.brandLogo1 &&
                                    React.createElement("img", { src: props.data.brandLogo1, alt: "" })))))))));
    };
    ProductCard.prototype.getImage = function (imgUrl, imgClass) {
        return (React.createElement("div", { className: "product-card-image text-center " + this.style.imgClass + " " + imgClass },
            React.createElement(Image_1.default, { lazyLoad: true, data: { url: imgUrl }, options: { alt: this.props.data.heading } })));
    };
    ProductCard.prototype.getFavourateIcon = function () {
        var _this = this;
        return (React.createElement(React.Fragment, null, this.props.data.addFavouriteContent &&
            React.createElement("div", { className: "absolute " + this.style.addFavouriteClass + " " + this.state.addFavouriteClass + " " + this.state.addFavouriteIconHover, onClick: function (ev) { return _this.props.data.onFavIconClick(ev); }, onKeyPress: function (ev) { return _this.props.data.onFavIconClick(ev); }, onTouchStart: this.props.data.onOffertouchStartEvt }, this.props.data.addFavouriteContent)));
    };
    ProductCard.prototype.colorOptions = function () {
        return (React.createElement("div", { className: "" + this.style.colorOptions }, this.props.data.colorOptions));
    };
    ProductCard.prototype.offerBanner = function () {
        var _this = this;
        return (React.createElement(React.Fragment, null, this.props.data.bannerText &&
            React.createElement("span", { 
                // prevent global card click event from happening
                onClick: function (ev) { return _this.props.data.onOfferClick(ev); }, onKeyPress: function (ev) { return _this.props.data.onOfferClick(ev); }, onTouchStart: this.props.data.onOffertouchStartEvt, className: this.style.bannerClass + " " + this.state.bannerClass + " \n                                " + this.props.data.bannerhover + " " + ProductCardStyles.bannerOffer + " ", "aria-label": "Special Offers", tabIndex: 0 }, this.props.data.bannerText)));
    };
    return ProductCard;
}(React.PureComponent));
exports.default = ProductCard;
//# sourceMappingURL=ProductCard.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/ProductCard/ProductCard.js
// module id = 1213
// module chunks = 8